import "./TaxonomyMapping.scss"
import React from "react";
import {observer} from "mobx-react-lite";
import {Button, Grid} from "@mui/material";
import {useNavigate} from "react-router";
import {useStores} from "../../../stores";
import {routes} from "../../../routing/routes";


export const TaxonomyFinish: React.FC = observer(() => {
    const {taxonomyIngestionStore} = useStores();
    const navigate = useNavigate();


    return (
        <div className="finish-component">
            <Grid>
                <Grid container justifyContent="center" alignItems="center" size={12}>
                    <h2>Finished creating a new dataset!</h2>
                </Grid>
                <Grid container justifyContent="center" alignItems="center" size={12}>
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={() => {
                            taxonomyIngestionStore.resetIngestionStore();
                            navigate(routes.home);
                        }}>
                        To the dashboard
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
})